import { useQuery } from "@apollo/client";
import React from "react";
import { GET_SALON_OPERATING_HOURS } from "@/graphql/configuration";

export function useOperatingHours(salonId?: string) {
  const { data, loading, error, refetch } = useQuery(GET_SALON_OPERATING_HOURS, {
    variables: { salonId: salonId ?? "" },
    skip: !salonId,
    fetchPolicy: "cache-first",
  });

  // Flatten all operating hours into a single array
  const operatingHours = React.useMemo(() => {
    if (!data?.getSalonOperatingHours?.weeklyHours) return [];

    return data.getSalonOperatingHours.weeklyHours
      .flatMap((day) => day.timeSlots)
      .filter((slot) => slot.startTime && slot.endTime);
  }, [data]);

  return {
    operatingHours,
    loading,
    error,
    refetch,
  };
}
